import { render } from "./SimplifiedPhoneInput.vue.ts?vue&type=template&id=fea77906&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./SimplifiedPhoneInput.vue?vue&type=template&id=fea77906&scoped=true&ts=true"
import script from "./SimplifiedPhoneInput.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./SimplifiedPhoneInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SimplifiedPhoneInput.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./SimplifiedPhoneInput.vue?vue&type=script&setup=true&lang=ts"

import "./SimplifiedPhoneInput.vue.scss?vue&type=style&index=0&id=fea77906&lang=scss&scoped=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./SimplifiedPhoneInput.vue?vue&type=style&index=0&id=fea77906&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fea77906"],['__file',"src/apps/merchant3/shared-components/input-fields/SimplifiedPhoneInput.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fea77906"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fea77906', __exports__)) {
    api.reload('fea77906', __exports__)
  }
  
  module.hot.accept("./SimplifiedPhoneInput.vue.ts?vue&type=template&id=fea77906&scoped=true&ts=true!=!../../../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./SimplifiedPhoneInput.vue?vue&type=template&id=fea77906&scoped=true&ts=true", () => {
    api.rerender('fea77906', render)
  })

}


export default __exports__